import { useSelector } from 'react-redux'
import { UnduePaymentInitial } from './components'
import { UNDUE_PAYMENT_STAGES } from './constants'

function stages() {
  return {
    [UNDUE_PAYMENT_STAGES.INITIAL]: <UnduePaymentInitial />,
  }
}

export function UnduePaymentDrawer() {
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages()[stage]
}
